(function($) {
    $(document).ready(function () {
        const location = $('.as-search-form #location');
        const locationContainer = $('.as-search-form .location-container');
        const propertySearch = $('.as-search-form');
        const otherFields = $('.as-search-form .input-container:not(first)');
        const searchButton = $('.as-search-form button');

        location.on('click keypress', function() {
            if ($(window).width() < 1025) {
                locationContainer.removeClass('closed');
                locationContainer.addClass('expanded');
                propertySearch.css('justify-content', 'center');
                searchButton.find('span').css('display', 'flex');
                searchButton.css('padding', '5px 20px 5px 10px');
                otherFields.slideDown();
                otherFields.addClass('slide-down');
            }
        });
    });
})(jQuery, this);
